import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { 
  Button, Alert, Intent, Divider, Spinner
} from '@blueprintjs/core';
import Pagination from 'components/Pagination';
import Footer from 'components/Footer';
import Toast from 'helpers/toaster';

@inject('store', 'clientStore', 'questionGroupStore', 'viewStore') @observer
class QuestionGroupsTable extends Component {
  @observable isOpenAddEquipmentDialog = false;
  @observable isDeleteDialogVisible = false;
  @observable group;

  onPaginationChange(newPage) {
    let {
      viewStore: {
        questionGroupSearch
      }
    } = this.props;
    this.props.viewStore.questionGroupSearch = {
      ...questionGroupSearch,
      page: newPage
    };
    this.props.viewStore.questionGroups();
  }

  handleDeleteCancel() {
    this.isDeleteDialogVisible = false;
  }

  handleDeleteConfirm() {
    this.isDeleteDialogVisible = false;
    this.props.questionGroupStore.deleteQuestion(this.group)
      .then(this.onSuccessfulDeleteQuestion.bind(this))
      .catch(this.onFailDeleteQuestion.bind(this))
  }

  onSuccessfulDeleteQuestion(response) {
    Toast.show({ icon: 'thumbs-up', message: 'Question group deleted successfully!', intent: Intent.SUCCESS })
    this.group = null;
    this.isDeleteDialogVisible = false;
  }

  onFailDeleteQuestion(error) {
    this.isDeleteDialogVisible = false;
    Toast.show({ icon: 'warning-sign', message: 'Unable to delete question group!', intent: Intent.DANGER })
  }

  handleServiceTypeClick(event, group) {
    switch (event.label) {
      case 'Edit':
        this.group = group;
        this.props.viewStore.questionGroupShow({uuid: group.attributes.id})
        break;
      case 'Delete':
        this.isDeleteDialogVisible = true;
        this.group = group;
        break;
      default:
    }
  }

  render() {
    let {
      viewStore,
      questionGroupStore: {
        groups: {
          objects,
          isLoading,
          meta
        }
      }
    } = this.props;

    if(isLoading) {
      return(
        <div className="display-spinner-center">
          <Spinner />
        </div>
      )
    }

    if(objects.length === 0) {
      return (
        <div className="bp3-callout bp3-icon-info-sign warning-alert-message bp3-intent-warning">
          <h4 className="bp3-heading">No Results</h4>
          Your search criteria returned no results. Please modify/expand your search parameters to see results.
        </div>
      )
    }
    return (
      <React.Fragment>
        <Footer>
          <div className="bp3-navbar-group bp3-align-left">
            <Pagination
              value={meta.page}
              total={meta.total_pages}
              onChange={this.onPaginationChange.bind(this)}
            />
          </div>
        </Footer>
        <div className="card rounded-0 table-responsive">
          <table className="table table-hover" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th width="15%">Name</th>
                <th>Question</th>
                <th className="item-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {
                objects.map((groups) => {
                  return (
                    <tr key={groups.id}>
                      <td>{groups.attributes.name}</td>
                      <td>{groups.attributes.question}</td>
                      <td>
                        <div className="action-buttons" minimal={'true'}>
                          <Button title="Edit" minimal={true} small={true} onClick={() => viewStore.questionGroupShow({uuid: groups.attributes.id})}>
                            <img src="/edit-light-icon.svg" alt="" />
                          </Button>
                          <Divider/>
                          <Button title="Delete" minimal={true} small={true} onClick={() => this.handleServiceTypeClick({ label: 'Delete' }, groups)}>
                            <img src="/delete-light-icon.svg" alt="" />
                          </Button>
                        </div>
                      </td>
                    </tr> 
                  )
                })
              }
            </tbody>
          </table>
        </div>
        <Alert
          cancelButtonText="Cancel"
          confirmButtonText="Delete"
          icon="trash"
          intent={Intent.DANGER}
          isOpen={this.isDeleteDialogVisible}
          onCancel={this.handleDeleteCancel.bind(this)}
          onConfirm={this.handleDeleteConfirm.bind(this)}
        >
          <p>Warnning! Deleting this question group will not be recoverable.</p>
          <p>Are you sure you want to do this?</p>
        </Alert>
        <Footer>
          <div className="bp3-navbar-group bp3-align-left">
            <Pagination
              value={meta.page}
              total={meta.total_pages}
              onChange={this.onPaginationChange.bind(this)}
            />
          </div>
        </Footer>
      </React.Fragment>
    )
  }

}

export default QuestionGroupsTable;